import $ from "jquery";

// Organisation number validation
$.validator.addMethod("organisationnumber", function (value, element, params) {

	value = value.match(/^(?:\d{2})?(\d)(\d)(\d)(\d)(\d)(\d)[-]?(\d)(\d)(\d)(\d)$/);
	if (value == null) return false;
	var n;
	var checkSum = 0;
	for (var i = 1; i < value.length; i++) {
		n = parseInt(value[i]);
		if (i % 2 === 0) {
			checkSum += n;
		} else {
			checkSum += (n * 2) % 9 + Math.floor(n / 9) * 9;
		}
	}

	if (checkSum % 10 === 0) {
		return true;
	}
	return false;

});
$.validator.unobtrusive.adapters.addBool("organisationnumber");